import React, { useEffect, useState } from "react";

import { connect, useDispatch, useSelector } from "react-redux";
import { Table, Tag, message, Dropdown } from "antd";
import ReactStars from "react-stars";
// import "antd/dist/antd.css";
// import { itemRender, onShowSizeChange } from "../../paginationfunction";

import { Link } from "react-router-dom";
import { EditInfo, DeleteModal } from ".";
import { apiURL } from "../../utils/config";
// import { getCourseOwners } from "../../appRedux/actions/courseOwners";
import { Avatar_02 } from "../../Routes/ImagePath";
import moment from "moment";
import { currencyConverter } from "../../utils/currency";
import { getCategoriesList } from "../../appRedux/actions/categories";
import axiosHttp from "../../appRedux/services/axiosCommon";



function ListView({searchText}) {
  const dispatch = useDispatch();
  const [list,setList]= useState([])
  const { categoryList} = useSelector(
    (state) => ({
      categoryList: state.categories.categoryList,
      queryInfo: state.categories.queryInfo,
      totalRecords: state.categories.totalRecords,
      selectedCurrency: state.common.selectedCurrency,
      currencyData: state.common.currencyData,
    })
  );

  useEffect(() => {
    console.log({searchText})
    if (searchText) {
      const filteredList = categoryList.filter(category =>
        category.name.toLowerCase().includes(searchText.toLowerCase())
      );
      setList(filteredList);
    } else {
      setList(categoryList);
    }
  }, [searchText, categoryList]);

    
  useEffect(()=>{setList(categoryList)},[categoryList])

  const handlePromoteToDomain = async (id) => {
    try {
      const res = await axiosHttp.post(`/api/v3/admin/domains/${id}/promote`);
      if (res.data?.success) {
        message.success("Category promoted to Domain successfully");
        dispatch(getCategoriesList({ page: 1, size: 10 }));
      }
    } catch (error) {
      message.error("Failed to promote category");
    }
  };

  const columns = [
    {
      title: "Category Name",
      dataIndex: "name",
      render: (name, record) => (
        <h2 className="table-avatar" style={{ textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
         {name}
        </h2>
      ),
      // width: "30px",
      // sorter: (a, b) => a.name.length - b.name.length,
    },
    
    {
      title: "Category Code",
      dataIndex: "code",
      align: "center",
      render: (code, record) => (
        <h2 className="table-avatar" style={{ textOverflow: "ellipsis", whiteSpace: "nowrap"  }}>
         {code}
        </h2>
      ),
    },
    {
      title: "Assigned Courses",
      dataIndex: "courseCount",
      align: "center",
      render: (count) => (
        <Tag color="blue">{count || 0} Courses</Tag>
      ),
    },


    {
      title: "Action",
      align: "center",
      fixed: "right",
      render: (text, record) => (
        <Dropdown
          dropdownRender={() => (
            <div className="dropdown-menu dropdown-menu-right show" style={{ display: 'block', position: 'static', margin: 0, boxShadow: 'none' }}>
              <EditInfo info={record} key={"edit_info"} />
              <button className="dropdown-item" onClick={() => handlePromoteToDomain(record._id)}>
                <i className="fa fa-sitemap m-r-5" /> Promote to Domain
              </button>
              <DeleteModal info={record} />
            </div>
          )}
          trigger={['click']}
          placement="bottomRight"
        >
          <Link
            to="#"
            className="action-icon"
            onClick={(e) => e.preventDefault()}
          >
            <i className="material-icons">more_vert</i>
          </Link>
        </Dropdown>
      ),
    },
  ];

  const itemRender = (_, type, originalElement) => {
    console.log(type, "a", originalElement);
    // if (type === "prev") {
    //   return (
    //     <i
    //       class="fa fa-angle-double-left"
    //       data-bs-toggle="tooltip"
    //       title="fa fa-angle-double-left"
    //     ></i>
    //   );
    // }
    // if (type === "next") {
    //   return (
    //     <i
    //       class="fa fa-angle-double-right"
    //       data-bs-toggle="tooltip"
    //       title="fa fa-angle-double-right"
    //     ></i>
    //   );
    // }
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return originalElement;
  };
  return (
    <div className="row m-0 mt-3">
      <div className="col-md-12 p-0" id="table-responsive">
        <div className="table-responsive" id="setMinheight">
          <Table
            className="table-striped"
            pagination={true}
            // pagination={{
            //   total: totalRecords,
            //   pageSizeOptions: ["5", "10", "20", "50"],
            //   showSizeChanger: true,
            //   showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
            //   onShowSizeChange: (current, pageSize) => {
            //     console.log({ current, pageSize });
            //     dispatch(
            //       getCategoriesList({
            //         ...queryInfo,
            //         page: current,
            //         size: pageSize,
            //       })
            //     );
            //   }, //onShowSizeChange,
            //   itemRender: itemRender,
            // }}
            // onChange={(pagination, filters, sorter) =>
            //   handleTableChange(pagination, filters, sorter)
            // }
            scroll={{ x: "max-content" }}
            columns={columns}
            // bordered
            dataSource={list}
            rowKey={(record) => record.id}
            // onChange={this.handleTableChange}
          />
        </div>
      </div>
    </div>
  );
}

export default ListView;
